import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage, injectIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';

// Redux Action
import { removeBlogPhotos } from '../../../actions/siteadmin/manageBlogPhotos';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// Locale
import messages from '../../../locale/messages';

import s from './BlogPhotosList.css';
import b from '../../ListPlaceStep1/ListPlaceStep1.css'

//Images
import DeleteImages from '../../../../public/SiteImages/Delete.svg';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import submit from '../EditBlogDetails/submit';

class BlogPhotosList extends Component {

  static propTypes = {
    removeBlogPhotos: PropTypes.any.isRequired,                               
    blogId: PropTypes.number.isRequired,
    blogPhotos: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      number: PropTypes.number.isRequired
    }))
  };

  static defaultProps = {
    blogPhotos: []
  };

  render() {
    const { removeBlogPhotos, blogId, blogPhotos, coverPhoto } = this.props;
    return (
      <div className={cx('row')}>
        {
          blogPhotos && blogPhotos.map((item, key) => {
            return (
              <div key={key} className={cx('col-lg-4 col-md-4 col-sm-6 col-xs-12 text-center')}>
                <div className={s.positionRelative}>
                  <div>
                    <div className={s.bgImage} style={{ backgroundImage: `url(/images/blog/${item.name})` }} />
                  </div>
                  <div className={b.coverPhotoSelection}>
                    <Field
                      className={cx(b.coverPhotoCheckbox, b.radioSize)}
                      type="radio"
                      component="input"
                      name="coverPhoto"
                      value={item.id}
                      checked={coverPhoto == item.id ? true : false}
                    />
                    <span> <FormattedMessage {...messages.coverLabel} /></span>
                  </div>
                </div>
                <span className={s.imageNumber}>{item.number}</span>
                <a href="javascript:void(0);" onClick={() => removeBlogPhotos(blogId, item.name, true, (coverPhoto == item.id))} className={s.deleteImageSection}>
                  <img src={DeleteImages} className={s.deleteImage} />
                </a>
              </div>
            );
          })
        }
      </div>
    );
  }

}

BlogPhotosList = reduxForm({
  form: 'BlogDetails', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: submit
})(BlogPhotosList);

const selector = formValueSelector('BlogDetails'); // <-- same as form name

const mapState = (state) => ({
  blogPhotos: state.blogDetails.blogPhotos,
  coverPhoto: selector(state, 'coverPhoto'),
});

const mapDispatch = {
  removeBlogPhotos,
};

export default withStyles(s, b)(connect(mapState, mapDispatch)(BlogPhotosList));


// WEBPACK FOOTER //
// src/components/siteadmin/BlogPhotosList/BlogPhotosList.js